module.exports = __webpack_public_path__ + "static/fonts/Montserrat800.e375c6fe.ttf";